import { render, staticRenderFns } from "./UserSignin.vue?vue&type=template&id=1ffcdc92"
import script from "./UserSignin.vue?vue&type=script&lang=js"
export * from "./UserSignin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports